package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.model.NotificationSettingToggle
import com.example.mystybag.appCore.model.NotificationSettingsUIState
import com.example.mystybag.appCore.logic.NavigatorSelectPage
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_DELIVERY
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_FAVORITES
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_HOME
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_PROFILE
import com.example.mystybag.communication.common.CommonCommands.sendUpdateNotificationSettings
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NOTIFICATIONS_DISCOUNTS_AND_NEWS_EMAIL
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NOTIFICATIONS_DISCOUNTS_AND_NEWS_PUSH
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NOTIFICATIONS_RESERVATION_COMPLETED_EMAIL
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_NOTIFICATIONS_RESERVATION_COMPLETED_PUSH
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_USER_ID
import com.example.mystybag.core.expected.Preferences.getBoolean
import com.example.mystybag.core.expected.Preferences.getLong
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.logic.base.MainCallback
import com.example.mystybag.sharedmodels.mystyBag.requestModels.UpdateNotificationSettingsRequestModel

class NotificationSettingsViewModel(context: AppContext) : ChildViewModel<NotificationSettingsUIState>(
    context = context,
    uiData = NotificationSettingsUIState(
        discountsAndNewsPushEnabled = getBoolean(key = PREFERENCES_NOTIFICATIONS_DISCOUNTS_AND_NEWS_PUSH, defaultValue = true),
        discountsAndNewsEmailEnabled = getBoolean(key = PREFERENCES_NOTIFICATIONS_DISCOUNTS_AND_NEWS_EMAIL, defaultValue = false),
        reservationCompletedPushEnabled = getBoolean(key = PREFERENCES_NOTIFICATIONS_RESERVATION_COMPLETED_PUSH, defaultValue = true),
        reservationCompletedEmailEnabled = getBoolean(key = PREFERENCES_NOTIFICATIONS_RESERVATION_COMPLETED_EMAIL, defaultValue = false)
    )
) {

    override fun onCreate() {
        navControls.title = sharedString(SR.strings.notifications)
    }

    fun onBackClick() {
        goBack()
    }

    /**
     * Единна команда за промяна на настройка за известия.
     * Извиква се при натискане на всеки от превключвателите в NotificationSettingsView.
     * Изпраща данните към сървъра.
     */
    fun onNotificationToggleChanged(toggle: NotificationSettingToggle, enabled: Boolean) {
        val currentState = uiState.value
        val newState = when (toggle) {
            NotificationSettingToggle.ReservationCompletedPush -> currentState.copy(reservationCompletedPushEnabled = enabled)
            NotificationSettingToggle.ReservationCompletedEmail -> currentState.copy(reservationCompletedEmailEnabled = enabled)
            NotificationSettingToggle.DiscountsAndNewsPush -> currentState.copy(discountsAndNewsPushEnabled = enabled)
            NotificationSettingToggle.DiscountsAndNewsEmail -> currentState.copy(discountsAndNewsEmailEnabled = enabled)
        }
        updateState { newState }

        val userId = getLong(PREFERENCES_USER_ID, 0L)
        val request = UpdateNotificationSettingsRequestModel(
            userId = userId,
            reservationCompletedPushEnabled = newState.reservationCompletedPushEnabled,
            reservationCompletedEmailEnabled = newState.reservationCompletedEmailEnabled,
            discountsAndNewsPushEnabled = newState.discountsAndNewsPushEnabled,
            discountsAndNewsEmailEnabled = newState.discountsAndNewsEmailEnabled
        )

        commandBlock(showProgress = false, hideProgress = false) {
            sendUpdateNotificationSettings(request).onResponse(
                success = { },
                baseError = { response ->
                    launchOnMain {
                        updateState { currentState }
                        showSnackbar(com.example.mystybag.communication.utils.Response.getErrorMessage(response.status, response.apiEndPoint, response.statusMessage))
                    }
                }
            )
        }
    }
}
